import { render, staticRenderFns } from "./MailAutoConfig.vue?vue&type=template&id=de7b18c0&scoped=true"
import script from "./MailAutoConfig.vue?vue&type=script&lang=ts"
export * from "./MailAutoConfig.vue?vue&type=script&lang=ts"
import style0 from "./MailAutoConfig.vue?vue&type=style&index=0&id=de7b18c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de7b18c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de7b18c0')) {
      api.createRecord('de7b18c0', component.options)
    } else {
      api.reload('de7b18c0', component.options)
    }
    module.hot.accept("./MailAutoConfig.vue?vue&type=template&id=de7b18c0&scoped=true", function () {
      api.rerender('de7b18c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/MailAutoConfig.vue"
export default component.exports